import { ajaxCall } from "@/shared/connection/ajax-call";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";
import { makeLogger } from "@/shared/consola";
import { makeNewSseHandler } from "@/shared/projects/sse-handler";
import { getAppOriginAPI } from "@/shared/connection/service.helpers";

const logger = makeLogger("pageOnboardingService");

const ENDPOINT = "/pages";

const EVENTS = {
    GENERATED: "page-generated",
    GENERATION_IN_PROGRESS: "page-generation-in-progress",
    GENERATION_IN_PROGRESS_SKELETON_READY: "page-generation-in-progress-skeleton-ready",
    GENERATION_ERROR: "page-generation-error",
};

export const pageOnboardingService = {
    EVENTS,
    sendOnboardData({
        mode,
        productDetails,
        promptDescription,
        lang,
        pageTemplate,
        pageId,
        pageUuid,
        theme,
    }) {
        return ajaxCall
            .post(`${ENDPOINT}/onboarding`, {
                mode,
                productDetails,
                promptDescription,
                lang,
                pageTemplate,
                pageId,
                pageUuid,
                theme,
            })
            .catch(handleErrorByMessage());
    },
    listenEventsFor(pageUUID, subscriber, onComplete) {
        return makeNewSseHandler(
            `${getAppOriginAPI() + ENDPOINT}/events/${pageUUID}`,
            {
                [EVENTS.GENERATION_IN_PROGRESS]: subscriber.onProgress,
                [EVENTS.GENERATION_IN_PROGRESS_SKELETON_READY]: subscriber.onProgressSkeletonReady,
                [EVENTS.GENERATED]: (e) => {
                    subscriber.onComplete(e);
                    onComplete?.(e);
                },
                [EVENTS.GENERATION_ERROR]: subscriber.onError,
            },
            logger
        );
    },
};
